import { PremiumAppealBanner } from "~/components/templates/common/purchase-modal/purchase-premium-appeal-banner/premium-appeal-banner";
import { G_ServicePlan } from "~/lib/graphql";
import { useAuth } from "~/provider/auth";

export const PurchasePremiumAppealBanner = () => {
  const { servicePlan, isLoggedIn, isFirstSubscribe } = useAuth();

  // プレミアム会員またはプレミアム会員の入会履歴がある場合、プレミアム訴求バナーを表示しない
  const hideBanner = servicePlan === G_ServicePlan.Premium || (isLoggedIn && !isFirstSubscribe);

  return !hideBanner ? <PremiumAppealBanner /> : null;
};
